/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Plugins_HeadingInputs */

const en_team_manager_plugins_heading = /** @type {(inputs: Team_Manager_Plugins_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plugin Management`)
};

const fr_team_manager_plugins_heading = /** @type {(inputs: Team_Manager_Plugins_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestion des plug-ins`)
};

const de_team_manager_plugins_heading = /** @type {(inputs: Team_Manager_Plugins_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plugin-Verwaltung`)
};

const it_team_manager_plugins_heading = /** @type {(inputs: Team_Manager_Plugins_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestione dei plugin`)
};

const ru_team_manager_plugins_heading = /** @type {(inputs: Team_Manager_Plugins_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление плагинами`)
};

const es_team_manager_plugins_heading = /** @type {(inputs: Team_Manager_Plugins_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestión de complementos`)
};

const zh_cn2_team_manager_plugins_heading = /** @type {(inputs: Team_Manager_Plugins_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插件管理`)
};

const ja_team_manager_plugins_heading = /** @type {(inputs: Team_Manager_Plugins_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プラグイン管理`)
};

const hi_team_manager_plugins_heading = /** @type {(inputs: Team_Manager_Plugins_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्लगइन प्रबंधन`)
};

const pt_pt2_team_manager_plugins_heading = /** @type {(inputs: Team_Manager_Plugins_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerenciamento de plugins`)
};

/**
* | output |
* | --- |
* | "Plugin Management" |
*
* @param {Team_Manager_Plugins_HeadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_plugins_heading = /** @type {((inputs?: Team_Manager_Plugins_HeadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Plugins_HeadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_plugins_heading(inputs)
	if (locale === "de") return de_team_manager_plugins_heading(inputs)
	if (locale === "it") return it_team_manager_plugins_heading(inputs)
	if (locale === "ru") return ru_team_manager_plugins_heading(inputs)
	if (locale === "es") return es_team_manager_plugins_heading(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_plugins_heading(inputs)
	if (locale === "ja") return ja_team_manager_plugins_heading(inputs)
	if (locale === "hi") return hi_team_manager_plugins_heading(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_plugins_heading(inputs)
	return en_team_manager_plugins_heading(inputs)
});